import { useAuthStore } from '@store/auth';

// Lee el access token desde el store en memoria (Pinia).
// localStorage nunca contiene el token — vive solo en memoria por seguridad.
export const authorization = (): string => {
  const store = useAuthStore();
  if (store.token) {
    return `Bearer ${store.token}`;
  }
  return '';
};